export default __webpack_public_path__ + "static/media/Oro-2Open.ad32be17.png";